<template>
    <div class="ml-poster">
        <div class="poster-inner">
            <img v-if="data.img" class="img" :src="data.img" />
            <!-- <div class="btn">
                <img class="btn-img" :src="data.buttonImg" />
            </div> -->
            <div class="qr" v-if="data.buttonImg">
                <p class="tip">长按二维码查看展商详情</p>
                <img class="qr-img" :src="data.buttonImg" @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: {
                // img: "https://ef-base-rules.oss-cn-beijing.aliyuncs.com/null/63207617__1648019343671.jpg",
                // buttonImg: "https://ef-base-rules.oss-cn-beijing.aliyuncs.com/null/62468123__1648019370202.png",
                // exhibitorId: "719a173bc3a347ab995355ffa084393d",
                // exhibitorName: "昆仑股份曹测试专用测试有限公司"
            }
        }
    },
    mounted() {
        this.getPoster()
    },
    methods: {
        async getPoster() {
            const id = this.$route.params.id
            const res = await this.$http.getPosterDetail({ id }).catch(err => {
                console.log(err)
            })
            console.log(res)
            const { code, data } = res
            if (code === 1000 && data) {
                this.data = data

                window.collectEvent('mianliao_poster_views', {
                    id: data.id,
                    exhibitionId: data.exhibitionId,
                    name: data.name
                });
            }
        },
        touchstart() {
            this.timer = setTimeout(() => {
                // 长按二维码埋点
                window.collectEvent('mianliao_poster_longPress', {
                    id: this.data.id,
                    exhibitionId: this.data.exhibitionId,
                    name: this.data.name
                })
            }, 500)
        },
        touchmove() {
            clearTimeout(this.timer)
        },
        touchend() {
            clearTimeout(this.timer)
        }
    }
}
</script>

<style scoped>
.ml-poster {
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
}
.poster-inner {
    position: relative;
}
.ml-poster .img {
    width: 100%;
    display: block;
}
.btn {
    width: 207px;
    height: 50px;
    position: fixed;
    bottom: 30px;
    left: 0;
    right: 0;
    margin: 0 auto;

}
.btn .btn-img {
    width: 100%;
    display: block;
}
.qr {
    width: 150px;
    position: absolute;
    bottom: 120px;
    left: 0;
    right: 0;
    margin: 0 auto;
}
.qr .tip {
    font-size: 12px;
    text-align: center;
    color: rgba(0, 0, 0, .6);
}
.qr .qr-img {
    width: 100%;
    display: block;
    width: 150px;
    height: 150px;
}
</style>